import classNames from 'classnames';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import { BubbleContent } from './bubbleContent';

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !['singleColumn', 'isCompleted'].includes(prop)
})(({ isCompleted, singleColumn, theme }) => ({
  ...theme.typography.body_mediumRegular,
  fontWeight: 'normal',
  textTransform: 'capitalizse',
  display: singleColumn && 'block',
  color: theme.palette.focus90.main,
  backgroundColor: theme.palette.peace10.main,
  height: '100%',
  padding: '0.75rem 1rem',
  borderStyle: 'solid',
  borderWidth: '1px 5px 5px 1px',
  borderColor: theme.palette.focus90.main,
  marginBottom: singleColumn && '0.5rem',
  '&:hover:not(.selected)': {
    backgroundColor: isCompleted && theme.palette.peace10.main,
    color: !isCompleted && theme.palette.focus00.main,
    cursor: isCompleted && 'default'
  },
  '&.selected': {
    color: theme.palette.focus00.main,
    backgroundColor: theme.palette.focus90.main,
    border: 0,
    '&:hover': {
      opacity: 0.7
    }
  }
}));

const StyledGrid = styled(Grid)({
  gap: '0.5rem'
});

const BubblePicker = ({
  options, selectedBubbles, onClick, completed, singleColumn, className
}) => {
  const bubbles = options.map((option) => {
    const isBubbleSelected = selectedBubbles.some((selected) => selected.text === option.text);

    return (
      <StyledButton
        isCompleted={completed}
        singleColumn={singleColumn}
        key={option.text}
        className={classNames(isBubbleSelected && 'selected')}
        onClick={() => onClick(option)}
      >
        <BubbleContent
          title={option.title || null}
          text={option.text}
          image={option.image || null}
          selected={isBubbleSelected}
        />
      </StyledButton>
    );
  });

  const content = singleColumn
    ? <Box className={className}>{bubbles}</Box> : (
      <StyledGrid container>
        {bubbles}
      </StyledGrid>
    );

  return content;
};

BubblePicker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string
  })).isRequired,
  selectedBubbles: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string
  })).isRequired,
  onClick: PropTypes.func.isRequired,
  completed: PropTypes.bool,
  singleColumn: PropTypes.bool
};

BubblePicker.defaultProps = {
  completed: false,
  singleColumn: false
};

export default BubblePicker;
